import React from 'react'

const HintIcon = props => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.667969 8.0013C0.667969 12.0514 3.95121 15.3346 8.0013 15.3346C12.0514 15.3346 15.3346 12.0514 15.3346 8.0013C15.3346 3.95121 12.0514 0.667969 8.0013 0.667969C3.95121 0.667969 0.667969 3.95121 0.667969 8.0013ZM14.0013 8.0013C14.0013 11.315 11.315 14.0013 8.0013 14.0013C4.68759 14.0013 2.0013 11.315 2.0013 8.0013C2.0013 4.68759 4.68759 2.0013 8.0013 2.0013C11.315 2.0013 14.0013 4.68759 14.0013 8.0013ZM8.67038 9.33353H9.33661V10.6669H6.66994V9.33353H7.33661V8.0002H6.66994V6.66687H8.67038V9.33353ZM8.66841 5.33353C8.66841 5.70172 8.36983 6.0002 8.00152 6.0002C7.63321 6.0002 7.33464 5.70172 7.33464 5.33353C7.33464 4.96534 7.63321 4.66687 8.00152 4.66687C8.36983 4.66687 8.66841 4.96534 8.66841 5.33353Z"
      fill="#4F5B94"
    />
  </svg>
)

export default HintIcon
